/** @jsx jsx */

import {
  Avatar,
  Colors,
  FloatingBox,
  Menu,
  MenuItem,
} from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

const Styles = {
  avatarButton: css`
    background-color: transparent;
    border: none;
    cursor: pointer;
  `,
  divider: css`
    background-color: ${Colors.neutral300};
    border: 0px;
    height: 1px;
    margin: 5px 0px;
    width: 100%;
  `,
  menuWrapper: css`
    padding: 10px;
  `,
  separator: css`
    border-top: 1px solid ${Colors.neutral300};
  `,
};

type Props = {
  isOpen: boolean;
  onClickLogOut?: () => void;
  onClickSettings?: () => void;
  onClickZapTemplates?: () => void;
  onClickZapier?: () => void;
  onToggle: () => void;
  urlLogOut: string;
  urlSettings: string;
  urlZapier: string;
  urlZapTemplates: string;
  user: {
    avatarUrl: string;
    name: string;
  };
};

const UserDropdown = ({
  isOpen,
  onClickLogOut,
  onClickSettings,
  onClickZapTemplates,
  onClickZapier,
  onToggle,
  urlLogOut,
  urlSettings,
  urlZapier,
  urlZapTemplates,
  user,
}: Props) => {
  return (
    <nav>
      <button css={Styles.avatarButton} onClick={() => onToggle()}>
        <Avatar
          isSelected={isOpen}
          name={user.name}
          size={40}
          url={user.avatarUrl}
        />
      </button>
      {isOpen && (
        <FloatingBox
          align="right"
          hasWhiteBackground={true}
          minWidth="198px"
          onClickOutside={event => {
            event.stopPropagation();
            onToggle();
          }}
          position="south"
        >
          <div css={Styles.menuWrapper}>
            <Menu ariaLabel="User options">
              <MenuItem href={urlZapTemplates} onClick={onClickZapTemplates}>
                Zapier Templates
              </MenuItem>
              <MenuItem href={urlSettings} onClick={onClickSettings}>
                Settings
              </MenuItem>
              <MenuItem href={urlZapier} onClick={onClickZapier}>
                Zapier.com
              </MenuItem>
              <hr css={Styles.divider} />
              <MenuItem href={urlLogOut} onClick={onClickLogOut}>
                Log out
              </MenuItem>
            </Menu>
          </div>
        </FloatingBox>
      )}
    </nav>
  );
};

export default UserDropdown;
